import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'
import { Field, Form } from 'redux-form'
import { asyncValidate, shouldAsyncValidate } from "redux-form-yup"
import withForm from 'with/Form'

import TextField from 'components/TextField'
import Button from 'components/buttons/Button'
import FormWithActions from 'layout/FormWithActions'
import Delete from 'components/Delete'

import { LoadingBox } from 'components/LoadingSpinner'


import DivisionsAPI from 'api/DivisionsAPI'
import handleFormErrors from 'utils/handleFormErrors'

import schema from './schema'
import styles from './index.css'

@withForm({
  asyncValidate : asyncValidate(schema),
  shouldAsyncValidate
})
export default class DivisionForm extends React.Component {
  
  static propTypes = {
    form     : PropTypes.string.isRequired,
    submitLabel : PropTypes.string,
    onClose : PropTypes.func,
    onSubmit : PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClose : () => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <Form form={this.props.form} onSubmit={handleSubmit}>
        <FormWithActions title={this.props.title}
          actions={[
            <Button 
              key={0}
              type='button'
              color='grey'
              onClick={() => this.props.onClose()}
              >
              Cancel
            </Button>
            ,
            <Button 
              key={1}
              loading={this.props.submitting}
              type='submit'
              color='orange' 
              style={{margin: '2rem 0rem'}}>
              {this.props.submitLabel || 'Save'}
            </Button>
          ]}>
          <Field 
            name='name' 
            label='Division Name'
            type='text'
            component={TextField} 
            />
        </FormWithActions>
      </Form>
    )
  }
}


export class AddDivisionForm extends React.Component {
    
  static propTypes = {
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await DivisionsAPI.create(values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <DivisionForm 
        form={"AddDivisionForm"}
        title={"Add Division"}
        submitLabel={"Add Division"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}



export class EditDivisionForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  state = {
    initialValues: null 
  }

  async componentDidMount() {
    const res = await DivisionsAPI.get(this.props.id)
    this.setState({ initialValues: { password: 'G0Od.4444', ...res.response } })
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (values) => {
    const {response} = handleFormErrors(await DivisionsAPI.update(this.props.id, values))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    const {initialValues} = this.state
    if (!initialValues) return <LoadingBox />
    return (
      <DivisionForm 
        initialValues={initialValues}
        form={"EditDivisionForm"}
        title={"Edit Division"}
        submitLabel={"Edit Division"}
        onClose={this.props.onClose}
        onSubmit={this.submit}
        />
    )
  }
}


export class DeleteDivisionForm extends React.Component {
    
  static propTypes = {
    id : PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onClose : PropTypes.func,
    onSubmitted: PropTypes.func,
  }

  static defaultProps = {
    onClose : () => {},
    onSubmitted: () => {}
  }

  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  submit = async (event) => {
    const {response} = handleFormErrors(await DivisionsAPI.delete(this.props.id))
    this.props.onSubmitted(response)
    this.props.onClose()
  }

  render() {
    return (
      <Delete 
        title={"Delete Division"}
        submitLabel={"Delete Division"}
        entityName={"this Division"}
        onCancel={this.props.onClose}
        onConfirm={this.submit}
        />
    )
  }
}



// WEBPACK FOOTER //
// ./src/forms/Division/index.jsx